import React, { Component } from 'react';
import { Table,  } from 'react-bootstrap';
import ApiService from '../../service/ApiService';
import { Link } from 'react-router-dom';
// import { convertDateForIos } from '../../service/Util';

class IPOCalender extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ipoCalenderList: [],
            limit: this.props.limit
        };
    }

    custom_sort(a, b) {
        return new Date(a.date).getTime() - new Date(b.date).getTime();
    }

    componentDidMount() {
        ApiService.getIPOCalender()
            .then(result => {
                console.log('IPO Calender', result);
                let filteredData = [];
                let length = this.state.limit;
                if (result.length > 0) {
                    length = result.length < length ? result.length : length;
                    let count = 0;
                    for (var i = result.length; i > 0; i--) {
                        if (count > length) { break; }
                        count++;
                        filteredData.push(result[i]);
                    }
                }
                this.setState({ ipoCalenderList: filteredData });
            })
            .catch((error) => {
                console.log(error);
            });

    }

    renderRow(listValue) {
        if (listValue !== undefined && listValue.symbol !== undefined) {
            let url = '/chart/' + listValue.symbol;
            return (
                <tr key={listValue.symbol}>
                    <td>{listValue.date}</td>
                    {/* <td><a href={url}>{listValue.symbol}</a></td> */}
                    <td><Link to={url}>{listValue.symbol}</Link></td>
                    <td style={{ textAlign: 'left' }}>{listValue.company.substring(0, 60)}</td>
                </tr>
            )
        }
    }

    render() {
        let tableRow;
        if (this.state.ipoCalenderList !== undefined && this.state.ipoCalenderList.length !== undefined && this.state.ipoCalenderList.length > 0) {
            tableRow = this.state.ipoCalenderList.map(this.renderRow.bind(this));
        } else {
            tableRow = <tr><td></td><td>No Data</td><td></td></tr>
        }
        console.log('ipoCalenderList', this.state.ipoCalenderList.length);
        return (
            // <div style={{ overflow: 'scroll', height: '475px' }}>
            // <Card border="secondary" style={{ height: '475px' }}>
            // <Card.Header>IPO Calender</Card.Header>    
                <Table striped bordered hover size="xs" style={{ fontSize: "10px" }} responsive>
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Ticker</th>
                            <th><Link to={'/ipoCalender'}>IPO Calender - Company</Link></th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableRow}
                    </tbody>
                </Table>
                // </Card>
            // </div>
        );
    }
}

export default IPOCalender;
